


























































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapMutations } from 'vuex';

@Component({
    computed: mapState(['modalData']),
    methods: mapMutations(['closeModal'])
})
export default class RemoveConnection extends Vue {
    success = false;
    error = false;
    fetching = false;

    modalData!: {
        partnerUuid: string;
        partnerName: string;
        connectionName: string;
        connectionUuid: string;
        successCallback: (connectionUuid: string) => void;
    }

    removeConnection() {
        const { dispatch } = this.$store,
            { connectionUuid, partnerUuid, successCallback } = this.modalData;

        this.error = false;
        this.fetching = true;

        dispatch('removeConnection', [connectionUuid, partnerUuid])
            .then(res => {
                if (res && res.status === 200) {
                    this.success = true;
                    successCallback(connectionUuid);
                } else {
                    this.error = true;
                }
            })
            .finally(() => this.fetching = false);
    }
}
